import { images } from '../constants';

const team = [ 
    {
        id: 1,
        image: images.team1,
        name: 'David Johnson',
        title: 'Garden Expert',
        biography: "David Johnson has been crafting breathtaking gardens for over a decade. His passion for greenery and expertise in landscaping transform outdoor spaces into serene havens. Dedicated to sustainability and aesthetics, David brings life to every project with his meticulous attention to detail. His designs incorporate eco-friendly practices and local plant species, ensuring that each garden thrives in harmony with nature. With a focus on innovative solutions, David creates spaces that are both beautiful and functional. Clients consistently praise his ability to turn their visions into vibrant, lasting landscapes.",
        contacts: {
            phone: '111-222-3344',
            email: 'david.johnson@example.com',
            website: 'www.davidjohnson.com',
        },
        accounts: {
            facebook: '#',
            linkedin: '#',
            twitter: '#',
            instagram: '#',
        },
        experience: {
            intro: 'Highlights of David’s Landscaping Expertise:',
            points: [ 
                'Eco-friendly garden designs',
                'Efficient use of outdoor spaces',
                'Creative plant arrangements',
                'Sustainable irrigation solutions',
                'Seamless integration of hardscapes',
            ],
        },
        skills: [
            {id: 1, title: 'Landscape Design', progress: 95},
            {id: 2, title: 'Horticulture Expertise', progress: 90},
            {id: 3, title: 'Customer Service', progress: 85},
        ],
    },
    {
        id: 2,
        image: images.team2,
        name: 'Emily Brown',
        title: 'Landscape Specialist',
        biography: 'Emily Brown is a passionate landscape specialist known for her ability to design breathtaking outdoor spaces. With a strong focus on sustainability and innovation, she transforms ordinary yards into stunning landscapes that inspire and captivate. Emily’s expertise lies in blending aesthetics with functionality, creating gardens that thrive in harmony with nature. Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam repellat dolore vero possimus consequatur pariatur suscipit distinctio accusantium! Consequuntur, cum! Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam repellat dolore vero possimus consequatur pariatur suscipit distinctio accusantium! Consequuntur, cum!',
        contacts: {
            phone: '222-333-4455',
            email: 'emily.brown@example.com',
            website: 'www.emilybrown.com',
        },
        accounts: {
            facebook: '#',
            linkedin: '#',
            twitter: '#',
            instagram: '#',
        },
        experience: {
            intro: 'Key Areas of Emily’s Landscaping Expertise:',
            points: [ 
                'Innovative landscape designs',
                'Expertise in native plants',
                'Efficient water management systems',
                'Integration of hardscaping elements',
                'Seasonal garden planning',
            ],
        },
        skills: [
            {id: 1, title: 'Sustainable Design', progress: 95},
            {id: 2, title: 'Plant Knowledge', progress: 90},
            {id: 3, title: 'Client Collaboration', progress: 85},
        ],
    },
    {
        id: 3,
        image: images.team3,
        name: 'Michael White',
        title: 'Gardening Consultant',
        biography: 'Michael White is a seasoned gardening consultant with a deep understanding of plant care, soil health, and sustainable gardening practices. His expertise spans from small home gardens to large-scale horticultural projects. Michael’s approach focuses on creating lush, thriving gardens that are both beautiful and environmentally friendly. Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam repellat dolore vero possimus consequatur pariatur suscipit distinctio accusantium! Consequuntur, cum! Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam repellat dolore vero possimus consequatur pariatur suscipit distinctio accusantium! Consequuntur, cum!',
        contacts: {
            phone: '333-444-5566',
            email: 'michael.white@example.com',
            website: 'www.michaelwhite.com',
        },
        accounts: {
            facebook: '#',
            linkedin: '#',
            twitter: '#',
            instagram: '#',
        },
        experience: {
            intro: 'Expertise in Sustainable Gardening Practices:',
            points: [ 
                'Plant health and maintenance',
                'Soil improvement and fertilization',
                'Organic gardening techniques',
                'Landscape planning and design',
                'Customized garden solutions',
            ],
        },
        skills: [
            {id: 1, title: 'Plant Care', progress: 95},
            {id: 2, title: 'Soil Management', progress: 90},
            {id: 3, title: 'Sustainable Gardening', progress: 85},
        ],
    },
    {
        id: 4,
        image: images.team4,
        name: 'Lisa Johnson',
        title: 'Landscape Designer',
        biography: 'Lisa Johnson is a skilled landscape designer with a passion for creating harmonious outdoor spaces. With an eye for detail and a love for nature, Lisa combines aesthetic appeal with functionality, designing landscapes that not only look beautiful but also serve practical purposes. Her designs emphasize sustainability, creativity, and the use of native plants to create stunning and low-maintenance gardens. Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam repellat dolore vero possimus consequatur pariatur suscipit distinctio accusantium! Consequuntur, cum! Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam repellat dolore vero possimus consequatur pariatur suscipit distinctio accusantium! Consequuntur, cum!',
        contacts: {
            phone: '444-555-6677',
            email: 'lisa.johnson@example.com',
            website: 'www.lisajohnson.com',
        },
        accounts: {
            facebook: '#',
            linkedin: '#',
            twitter: '#',
            instagram: '#',
        },
        experience: {
            intro: 'Areas of Expertise in Landscape Design:',
            points: [ 
                'Designing functional outdoor spaces',
                'Utilizing native and drought-tolerant plants',
                'Incorporating sustainable materials',
                'Creating serene garden environments',
                'Transforming small spaces into lush gardens',
            ],
        },
        skills: [
            {id: 1, title: 'Landscape Architecture', progress: 95},
            {id: 2, title: 'Creative Planting', progress: 90},
            {id: 3, title: 'Sustainable Design', progress: 85},
        ],
    }
];

export default team;